module.exports = __webpack_public_path__ + "static/img/cp6.c3061f0e.png";